import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import OperatorsApiManager from '../../../api/services/OperatorsApiManager'
import { useTranslation } from 'react-i18next'

function UserForm() {
    const { t } = useTranslation()
    const [validated, setValidated] = useState(false)
    const [username, setUsername] = useState('')
    const [correo, setCorreo] = useState('')
    const [password, setPassword] = useState('')
    const [rol, setRol] = useState('operators-user')

    const navigate = useNavigate()

    const handleSubmit = async (event) => {
        const form = event.currentTarget
        if (form.checkValidity() === false) {
            event.preventDefault()
            event.stopPropagation()
            setValidated(true)
            return;
        }

        event.preventDefault()
        setValidated(true)

        var response = await OperatorsApiManager.createUserInOperator({
            email: correo,
            username: username,
            password: password,
            group_role: rol,
        }).catch((error) => {
            console.error(error)
            toast.error(error.message)
        })
        if (response) {
            toast.success(t('alerts.user_created'))
            navigate('/operadores/usuarios')
        }
    }

    return (
        <div className="col-12 grid-margin stretch-card">
            <ToastContainer />
            <div className="card">
                <div className="card-body">
                    <h4 className="card-title">
                        {t('form_user_title')}
                    </h4>
                    <p className="card-description">
                        {t('form_user_description')}
                    </p>
                    <Form
                        noValidate
                        validated={validated}
                        onSubmit={handleSubmit}
                    >
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom01"
                        >
                            <Form.Label>{t('auth.login.username')}</Form.Label>
                            <Form.Control
                                type="text"
                                className="form-control"
                                value={username}
                                required
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder={t('username_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom02"
                        >
                            <Form.Label>{t('email_title')}</Form.Label>
                            <Form.Control
                                type="email"
                                className="form-control"
                                value={correo}
                                required
                                onChange={(e) => setCorreo(e.target.value)}
                                placeholder={t('email_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom03"
                        >
                            <Form.Label>{t('auth.login.password')}</Form.Label>
                            <Form.Control
                                type="password"
                                className="form-control"
                                value={password}
                                required
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder={t('password_placeholder')}
                            />
                        </Form.Group>
                        <Form.Group
                            className="form-group"
                            controlId="validationCustom04"
                        >
                            <Form.Label>{t('rol_title')}</Form.Label>
                            <Form.Select
                                aria-label="Example select"
                                className="form-select"
                                value={rol}
                                required
                                onChange={(e) => setRol(e.target.value)}
                            >
                                <option id="operators-user" value='operators-user'>Suscriptor</option>
                                <option id="operators-operator_admin" value='operators-operator_admin'>
                                    Operador
                                </option>
                            </Form.Select>
                        </Form.Group>
                        <Button
                            variant="btn btn-primary"
                            className="me-2"
                            type="submit"
                        >
                            {t('button.save')}
                        </Button>
                        <Button
                            variant="btn btn-light"
                            onClick={() => navigate(-1)}
                        >
                            {t('button.cancel')}
                        </Button>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default UserForm
